import { Switch, Route, useRouteMatch } from "react-router-dom";
import { listcustomerrating, listcutomersales, listnewcustomer, listrepeatcustomer,listorderhistoryreport } from "../screens/ReportScreens";
import routes from "./URL";
export default function gallery_image_routes() {
    return (
        <Switch>
            
            <Route
                path={routes.admin.reports.categorysales(":hotelSlug")}
                component={listcutomersales}
            />
            <Route
                path={routes.admin.reports.customerrating(":hotelSlug")}
                component={listcustomerrating}
            />

            <Route
                path={routes.admin.reports.newcustomer(":hotelSlug")}
                component={listnewcustomer}
            />
            <Route
                exact
                path={routes.admin.reports.repeatcustomer(":hotelSlug")}
                component={listrepeatcustomer}
            />
                        <Route
                exact
                path={routes.admin.reports.orderhistory(":hotelSlug")}
                component={listorderhistoryreport}
            />
            {/* <Route exact path={"/"} component={ListGalleryScreen} /> */}
        </Switch>
    );
}